import {defineStore} from "pinia";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useApi} from "@/services/useApi.js";

export const useInboxStore = defineStore('inbox', {
  state: () => ({
    inboxMessages: []
  }),
  getters: {
    getMessages(state) {
      return [...state.inboxMessages].sort(
        (a, b) => b.sendTime - a.sendTime
      )
    },
    getLastUnreadMessageID(state) {
      return state.inboxMessages.find(
        message => !message.deliverTime
      )?.id
    },
    getUnreadMessagesCount(state) {
      return state.inboxMessages?.filter(message => !message.deliverTime).length
    },
  },
  actions: {
    async action_getAllInbox() {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 2097,
      };
      //console.log('action_getAllInbox: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getAllInbox Success: ', response);
          this.inboxMessages = response.data.account.inbox.messages
          return {
            result: true,
            data: response.data.account.inbox.messages
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    async action_setDelivery() {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 2099,
        "account": {
          ...getAuthenticatedRequest().account,
          "inbox": {
            "message": {
              "id": this.getLastUnreadMessageID
            }
          }
        }
      };
      console.log('action_setDelivery: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_setDelivery Success: ', response);
          return {
            result: true,
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
  }
})